import { api } from './api';

export const getAppVersions = () => api.get('/admin/app-versions');
export const updateAppVersion = (id: string, data: { minRequiredVersion?: string; latestVersion?: string; forceUpdate?: boolean }) =>
  api.patch(`/admin/app-versions/${id}`, data);
